/**
 * Feature Access Configuration
 *
 * Centralized configuration for controlling feature visibility and access
 * based on feature flags and user permissions.
 *
 * Each feature can have:
 * - featureFlag: LaunchDarkly feature flag key (org-specific)
 * - permission: Permission key from user roles (string key from getZaniaTeamMemberRoles)
 * - redirectTo: Route to redirect to if access is denied
 */

import { ROUTES } from "@/shared/constants/routes";

export type FeatureAccessConfig = {
  featureFlag?: string;
  permission?: string;
  redirectTo?: string;
};

export const FEATURE_ACCESS_CONFIG: Record<string, FeatureAccessConfig> = {
  tpraDashboard: {
    featureFlag: "enablePylonChat",
    redirectTo: ROUTES.AGENT,
  },
  vendors: {
    permission: "canAccessZaniaVendorAssessment",
    redirectTo: ROUTES.AGENT,
  },
  askZania: {
    permission: "canAccessZaniaAskAi",
    redirectTo: ROUTES.AGENT,
  },
} as const;

export type FeatureName = keyof typeof FEATURE_ACCESS_CONFIG;
